<form id="dynamic-form" [formGroup]="form">
  <div [ngClass]="{'column-count-2': (isSmallScreen | async)}">
    @for (control of controls; track control) {
      <app-control [control]="control" [form]="form">
      </app-control>
    }
  </div>
</form>